module.exports = __webpack_public_path__ + "static/media/logo-only.61a993ab.png";